/* eslint-disable */
// modalProps -- Select 相关制定设置
// actionChange: 父级组件 回掉方法
// refQ: handerControl 重置状态， 默认关闭，如果开启，重新获取一次query内数据
import React, { useState, useEffect, useMemo } from 'react'
import { Select, Divider } from 'antd'
import { omit } from 'lodash'
import { handleControl } from './control'
import { renderLabelString, renderTextUn } from '@/utils/renderUtils'

const SelectOption = Select.Option
 
const I2SelectControl = (props) => {
  const {
    propsClassName, propsStyle, propsClassSpan, style,// 样式 className
    modalProps, label, ending, optionDisabled,// 组件 功能参数
    options, query, value, searchKey, // 组件 数据源
    clearKey, killPending, reduxObj, dropdownRender,// 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props
  // 将 query[searchKey] 转换为字符串，确保类型一致
  const getStringValue = (val) => {
    if (val === undefined || val === null || val === '') {
      return ''
    }
    return String(val)
  }

  const handleValue = modalProps.mode && query[searchKey]
    ? query[searchKey].split(',').map(v => getStringValue(v))
    : getStringValue(query[searchKey])

  // 初始化select组件选中项 以及接管选择
  const [ useValue, setUseValue ] = useState(handleValue)
  useEffect(() => {
    setUseValue(handleValue)
  }, [query.refQ, query[searchKey]]) // 监听是否要重置

  const onChangeSelect = (e, option) => {
    setUseValue(e)
    // ----- 处理数据 -----------
    let formatValue = e
    if (!e || e.length <= 0) {
      formatValue = ''
    } else {
      // 确保存储的值是字符串类型
      formatValue = modalProps.mode
        ? e.map(v => String(v)).join(',')
        : String(e)
    }
    // ----- 提交组件 -----------
    handleControl(
      props,
      { [searchKey]: `${formatValue}` },
      option
    )
  }

  const handleDropdown = () => {
    // 目前只有全选方法
    const mapData = options.map(item => item.id)
    onChangeSelect(mapData)
  }
  const dropdown = () => {
    if (!dropdownRender) { return '' }
    return (
      <>
        <Divider style={{ margin: '4px 0' }} />
        <div
          style={{ padding: '4px 8px', cursor: 'pointer' }}
          onMouseDown={e => e.preventDefault()}
          onClick={handleDropdown}
        >
          {React.cloneElement(dropdownRender)}
        </div>
      </>
    )
  }

  const hanldeLabel = (value) => {
    if (ending) {
      const subValue = value.length > 12 ? `...${value.substring(value.length - 11)}` : value
      return subValue
    }
    return value
  }

  const filterOption = (inputValue, option) => {
    const formatInputValue = String(inputValue || '').toLowerCase()
    const extra = option && option.option
    const phone = extra && extra.phone != null ? String(extra.phone).toLowerCase() : ''
    if (phone && phone.indexOf(formatInputValue) > -1) return true
    const raw = option && (typeof option.children === 'string' ? option.children : option.label)
    const text = typeof raw === 'string' ? raw.toLowerCase() : ''
    if (!text) return false
    /**
     * 如果输入是英文，则从左开始 匹配
     */
    const allEng = /[a-zA-Z]$/.test(inputValue)
    if (allEng) {
      const regex = RegExp(('^' + formatInputValue))
      return regex.test(text)
    }
    return text.indexOf(formatInputValue) > -1
  }

  const renderedOptions = useMemo(() => {
    return options.map(item => (
      <SelectOption
        option={item}
        key={item.id}
        value={item.id}
        label={hanldeLabel(item.value)}
        disabled={optionDisabled(item)}
      >
        {item.value}
      </SelectOption>
    ))
  }, [options, optionDisabled, ending])

  return (
    <div className={propsClassName} style={propsStyle}>
      <span
        className={propsClassSpan}
        style={{ marginRight: '8px', display: 'inline-flex', alignItems: 'center' }}
      >
        {renderLabelString(label)}
      </span>
      <Select
        // -- modalProps
        style={style}
        placeholder={`请选择${renderTextUn(label)}`}
        allowClear={true}
        showSearch={true}
        maxTagCount='responsive'
        listHeight={256}
        listItemHeight={24}
        getPopupContainer={trigger => trigger.parentNode}
        {...modalProps}
        // ---
        onChange={onChangeSelect}
        filterOption={filterOption}
        value={useValue}
        optionLabelProp='label'
        dropdownMatchSelectWidth={false}
        dropdownRender={(menu) => {
          return (
            <>
              {menu}
              {dropdown()}
            </>
          )
        }}
      >
        {renderedOptions}
      </Select>
    </div>
  )
}
export default I2SelectControl

I2SelectControl.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  style: { minWidth: 200 },
  modalProps: {},
  optionDisabled: () => {},
  query: {},
  options: [],
  ending: false,
  killPending: false,
  dropdownRender: false
}
